import React from 'react';
import { Helmet } from 'react-helmet-async';
import styles from './ThankYouPage.module.css';

const ThankYouPage: React.FC = () => {
  return (
    <>
      <Helmet>
        <title>Brands2Buyers - Merci !</title>
        <meta property="og:title" content="Brands2Buyers - Merci !" />
        <meta name="twitter:title" content="Brands2Buyers - Merci !" />
        <meta property="og:type" content="website" />
        <meta name="twitter:card" content="summary_large_image" />
      </Helmet>
      {/* Hero */}
      <section className={styles.heroSection}>
        <div className={styles.heroContainer}>
          <h1 className={styles.heroTitle}>BRANDS2BUYERS 2025</h1>
          <p className={styles.heroSubtitle}>ON L'A FAIT !</p>
        </div>
      </section>

      {/* Intro — fond blanc */}
      <section className={styles.introSection}>
        <div className={styles.introInner}>
          <img
            src="https://cdn.prod.website-files.com/6708d197c044d369ae5e3a2d/67a8a4e505ef8a03dfe8639b_Brands2Buyers%40Anna%20Ellouk%20Photographe-174.jpg"
            alt="Brands2Buyers soirée"
            className={styles.bannerImage}
          />

          <div className={styles.introContent}>
            {/* Cassette à GAUCHE */}
            <div className={styles.cassetteBlock}>
              <img
                src="https://cdn.prod.website-files.com/6708d197c044d369ae5e3a2d/670ff1773c373987b8e1dadc_AlbedoBase_XL_90s_enceinte_portable_cassette_1.jpg"
                alt="Cassette 90s"
                className={styles.cassetteImage}
                loading="lazy"
              />
            </div>
            {/* Titre + liste à DROITE */}
            <div className={styles.introTextBlock}>
              <h3 className={styles.introH3}>🔥 Les temps forts de cette soirée so 80's AND 90's :</h3>
              <ul className={styles.introList}>
                <li>Des top décideurs B2B qui sont sortis de leurs bureaux !</li>
                <li>Des sponsors qui déchirent : Algolia et Valtech 🫶</li>
                <li>
                  2 talks inspirants avec{' '}
                  <a href="https://www.linkedin.com/in/paulparmentier/" target="_blank" rel="noreferrer">Paul Parmentier</a>,{' '}
                  <a href="https://www.linkedin.com/in/josebadana/" target="_blank" rel="noreferrer">José Badana</a>{' '}
                  et{' '}
                  <a href="https://www.linkedin.com/in/thibaultbruniau/" target="_blank" rel="noreferrer">Thibault Bruniau</a>
                </li>
                <li>
                  Des tonnes d'insights B2B commerce grâce à{' '}
                  <a href="https://www.linkedin.com/in/rudyabitbol/" target="_blank" rel="noreferrer">Rudy Abitbol Caribou</a>{' '}🇨🇦
                </li>
                <li>❤️ Une avalanche de good vibes sur LinkedIn :</li>
              </ul>
              {/* Grille 2 colonnes : gauche 2 images, droite 3 images */}
              <div className={styles.screenshotsGrid}>
                <div className={styles.screenshotsCol}>
                  <img src="https://cdn.prod.website-files.com/6708d197c044d369ae5e3a2d/67a8ab80b7099ec394996305_Capture%20d%E2%80%99e%CC%81cran%202025-02-09%20a%CC%80%2014.08.28.png" alt="LinkedIn post" loading="lazy" />
                  <img src="https://cdn.prod.website-files.com/6708d197c044d369ae5e3a2d/67a8ab80a5f6ea768b52087c_Capture%20d%E2%80%99e%CC%81cran%202025-02-09%20a%CC%80%2014.14.00.png" alt="LinkedIn post" loading="lazy" />
                </div>
                <div className={styles.screenshotsCol}>
                  <img src="https://cdn.prod.website-files.com/6708d197c044d369ae5e3a2d/67a8ab879a2e5a49b5e23f92_Capture%20d%E2%80%99e%CC%81cran%202025-02-09%20a%CC%80%2014.14.52.png" alt="LinkedIn post" loading="lazy" />
                  <img src="https://cdn.prod.website-files.com/6708d197c044d369ae5e3a2d/67a8ab808a55c09f118252d2_Capture%20d%E2%80%99e%CC%81cran%202025-02-09%20a%CC%80%2014.15.18.png" alt="LinkedIn post" loading="lazy" />
                  <img src="https://cdn.prod.website-files.com/6708d197c044d369ae5e3a2d/67a8ab80ec83ba630f4b3498_Capture%20d%E2%80%99e%CC%81cran%202025-02-09%20a%CC%80%2014.14.34.png" alt="LinkedIn post" loading="lazy" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Now what? — fond blanc, centré */}
      <section className={styles.nowWhatSection}>
        <div className={styles.nowWhatInner}>
          <h1 className={styles.nowWhatTitle}>Now what?</h1>
          <h1 className={styles.nowWhatSubtitle}>On vous a concocté un petit diaporama des meilleurs moments</h1>
          <p className={styles.nowWhatText}>
            📸 Les photos de la soirée →{' '}
            <a href="https://photos.app.goo.gl/XE9WoYkmg5dskVaV6" target="_blank" rel="noreferrer">Voir l'album</a>
          </p>
          <p className={styles.nowWhatText}>📺 La vidéo is coming very soon, on le promet !</p>

          <h1 className={styles.nowWhatSubtitle}>🛍️ Vous souhaitez partager toutes les tendances abordées ?</h1>
          <p className={styles.nowWhatText}>
            <a href="https://drive.google.com/file/d/1K6TLbnn1LLUl9g6VzX2ocXSAN44T-W79/view" target="_blank" rel="noreferrer">Voir la présentation</a>
            {' '}|{' '}
            <a href="https://www.calameo.com/read/007862432de0f2263a779" target="_blank" rel="noreferrer">Lire le Magazine</a>
          </p>

          <h1 className={styles.nowWhatSubtitle}>💯 Donnez-nous votre feedback please !</h1>
          <p className={styles.nowWhatText}>
            Vos retours sont précieux...{' '}
            <a href="mailto:hello@brands2buyers.io">hello@brands2buyers.io</a>
          </p>

          <h1 className={styles.nowWhatSubtitle}>📱 Rejoindre le groupe WhatsApp Le Café de L'E-Commerce 100% B2B</h1>
          <p className={styles.nowWhatText}>
            <a href="https://chat.whatsapp.com/KN6a2NAqGUB6pHnjqvFqin" target="_blank" rel="noreferrer">Cliquez ICI</a>
          </p>
        </div>
      </section>

      {/* Section finale */}
      <section className={styles.finaleSection}>
        <div className={styles.finaleInner}>
          <h1 className={styles.finaleTitle}>
            On a hâte de vous retrouver pour de nouvelles aventures ! Brands2Buyers revient dans le futur, à l'été 2025 si vous souhaitez encore plus de karaoké, de beerpong et de popcorn !
          </h1>
          <img
            src="https://cdn.prod.website-files.com/6708d197c044d369ae5e3a2d/67a8b282b7099ec3949e9b4e_gif%20mj.gif"
            alt="Marty McFly"
            className={styles.gifImage}
            loading="lazy"
          />
        </div>
      </section>

      {/* Signature — fond rose B2B */}
      <section className={styles.signatureSection}>
        <h1 className={styles.signatureTitle}>Adrien, Laetitia &amp; la B2B Squad</h1>
      </section>
    </>
  );
};

export default ThankYouPage;
